var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVatAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17891 15.1629C9.64844 13.2772 13 8.70679 13 6.13959C13 3.02607 10.5365 0.5 7.5 0.5C4.46354 0.5 2 3.02607 2 6.13959C2 8.70679 5.35156 13.2772 6.82109 15.1629C7.17344 15.6124 7.82656 15.6124 8.17891 15.1629ZM7.5 4.25973C7.98623 4.25973 8.45255 4.45779 8.79636 4.81033C9.14018 5.16287 9.33333 5.64102 9.33333 6.13959C9.33333 6.63817 9.14018 7.11632 8.79636 7.46886C8.45255 7.8214 7.98623 8.01946 7.5 8.01946C7.01377 8.01946 6.54745 7.8214 6.20364 7.46886C5.85982 7.11632 5.66667 6.63817 5.66667 6.13959C5.66667 5.64102 5.85982 5.16287 6.20364 4.81033C6.54745 4.45779 7.01377 4.25973 7.5 4.25973Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatAddress);
export default __webpack_public_path__ + "static/media/vat-address.313203da452435743bddb2da042e5b25.svg";
export { ForwardRef as ReactComponent };